/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/






// Patch ResizeObserver before anything else mounts an editor / observes layout.
import './utils/resizeObserverFix';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import "./i18n";
// Sends the signed-in user's ID token with every backend call. Must load before
// anything can make one.
import "./services/apiAuth";

import 'assets/vendor/nucleo/css/nucleo.css';
import 'assets/vendor/font-awesome/css/font-awesome.min.css';
import 'assets/scss/argon-design-system-react.scss?v1.1.0';
// Site-wide tokens, type and motion helpers. After Argon so it can refine it.
import './styles/premium.css';

import App from './App';






import * as monaco from 'monaco-editor';


// Dev-only: suppress the ResizeObserver loop error noise
if (process.env.NODE_ENV === "development") {
  // Trap the browser error event (not just console.error)
  const roErrorHandler = (e) => {
    const msg = e?.message || "";
    if (msg.includes("ResizeObserver loop") || msg.includes("undelivered notifications")) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  };
  window.addEventListener("error", roErrorHandler, true);
}



const root = ReactDOM.createRoot(document.getElementById('root'));



root.render(

  <BrowserRouter>
    <App />
  </BrowserRouter>

);

